export default "__VITE_ASSET__CRhBnju0__"